import React from "react";
// import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs/index.js";
import { DatePicker } from "@mui/x-date-pickers/DatePicker/index.js";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider/index.js";

import * as BoxModule from "@mui/material/Box/index.js";
import * as FormHelperTextModule from "@mui/material/FormHelperText/index.js";
import * as TextFieldModule from "@mui/material/TextField/index.js";
import { resolveDefault } from "../../utils/moduleInterop";

const Box = resolveDefault<any>(BoxModule);
const FormHelperText = resolveDefault<any>(FormHelperTextModule);
const TextField = resolveDefault<any>(TextFieldModule);

interface DateSelectorProps {
	id?: string;
	label?: string;
	name: string;
	placeholder?: string;
	value: any;
	error?: any;
	setFieldValue: (
		field: string,
		value: any,
		shouldValidate?: boolean
	) => void;
	disabled?: boolean;
	touched?: { [key: string]: boolean };
}

const DateSelector: React.FC<DateSelectorProps> = (props) => {
	const handleChange = (value: any) => {
		props.setFieldValue(props.name, value);
	};

	const renderInput = (params: any) => {
		return <TextField {...params} />;
	};

	return (
		<Box>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<DatePicker
					views={["year", "month", "day"]}
					label={`${props.label}(MM/DD/YYYY)`}
					value={props.value}
					onChange={handleChange}
					renderInput={renderInput}
					disabled={props.disabled}
				/>
			</LocalizationProvider>
			{props.error && (
				<FormHelperText error>{props.error}</FormHelperText>
			)}
		</Box>
	);
};

DateSelector.defaultProps = {
  label: "Date",
};

export default DateSelector;
